import { SearchResultItem } from './search.app';

export enum HeaderSearchCategory {
	Clients = 1,
	Institutions = 2,
	Users = 3,
	Sponsors = 4,
	IntegrationServiceOffices = 5,
	Assignments = 6,
	InstitutionPersons = 7,
}

export const HEADER_SEARCH_CATEGORIES = [
	HeaderSearchCategory.Clients,
	HeaderSearchCategory.Institutions,
	HeaderSearchCategory.InstitutionPersons,
	HeaderSearchCategory.Sponsors,
	HeaderSearchCategory.Users,
	HeaderSearchCategory.IntegrationServiceOffices,
	HeaderSearchCategory.Assignments,
] as const;

export interface HeaderSearchQuery {
	searchTerm: string;
	categories: HeaderSearchCategory[];
	limitPerCategory?: number;
	offset?: number;
}

export interface HeaderSearchResponse {
	groups: HeaderSearchGroupResult[];
}

export interface HeaderSearchGroupResult {
	category: HeaderSearchCategory;
	items: SearchResultItem[];
	hasMore: boolean;
	rawCount: number;
}

export const SEARCH_MIN_CHARS = 3;

// Matches the backend validation limit; count the untrimmed value sent to the API.
export const SEARCH_MAX_CHARS = 200;

// Default page size for the infinite-scroll "load more" request per search group
export const SEARCH_PAGE_SIZE = 20;

// Upper bound on additional "load more" pages per group, guarding against runaway pagination
export const LOAD_MORE_SAFETY_CAP = 10;

export interface GroupLoadState {
	backendOffset: number;
	isLoadingMore: boolean;
	loadMoreError: boolean;
	pagesLoaded: number;
}

export const createDefaultGroupLoadStates = (): Record<HeaderSearchCategory, GroupLoadState> => ({
	[HeaderSearchCategory.Clients]: { backendOffset: 0, isLoadingMore: false, loadMoreError: false, pagesLoaded: 0 },
	[HeaderSearchCategory.Institutions]: { backendOffset: 0, isLoadingMore: false, loadMoreError: false, pagesLoaded: 0 },
	[HeaderSearchCategory.Users]: { backendOffset: 0, isLoadingMore: false, loadMoreError: false, pagesLoaded: 0 },
	[HeaderSearchCategory.Sponsors]: { backendOffset: 0, isLoadingMore: false, loadMoreError: false, pagesLoaded: 0 },
	[HeaderSearchCategory.IntegrationServiceOffices]: {
		backendOffset: 0,
		isLoadingMore: false,
		loadMoreError: false,
		pagesLoaded: 0,
	},
	[HeaderSearchCategory.Assignments]: { backendOffset: 0, isLoadingMore: false, loadMoreError: false, pagesLoaded: 0 },
	[HeaderSearchCategory.InstitutionPersons]: {
		backendOffset: 0,
		isLoadingMore: false,
		loadMoreError: false,
		pagesLoaded: 0,
	},
});
